import AdditionalInfo from '../../schema/innerSchema/AdditionalInfo';

export const SCHEMA_ORG_PARSER = 'schema.org parser';
export const SCHEMA = 'schema';
export const EXTRACTION = 'extraction';

/**
 * Calculates origin based on the information from the TXP blob
 * @param txpAdditionalInfo additional info received from the raw entity data
 * @param source source of the entity
 */
export default function calculateOrigin(txpAdditionalInfo: AdditionalInfo, source: string): string {
    let origin = null;
    if (txpAdditionalInfo !== undefined && txpAdditionalInfo !== null) {
        origin = AdditionalInfo[txpAdditionalInfo];
    } else if (source) {
        origin = source.toLowerCase().indexOf(SCHEMA_ORG_PARSER) > -1 ? SCHEMA : EXTRACTION;
    }
    return origin;
}
